import { HttpClient } from 'api/http-client';
import {
  AccountSignalsSidebarItemsResponse,
  SignalOccurenceLightResponse,
} from './types';

class AllSignalsAPIClient extends HttpClient {
  public async getSignalsByType(type: string): Promise<any> {
    return this.get<any[]>(`/${type}`);
  }
  public async getSidebarItems(): Promise<any> {
    return this.get<any[]>('/sidebar');
  }

  public getAllSignalsSidebarItems(
    companyId: number,
  ): Promise<AccountSignalsSidebarItemsResponse> {
    return this.get<AccountSignalsSidebarItemsResponse>(
      `signals/configurations/getSignalConfigurationStats?companyId=${companyId}`,
    );
  }

  public getAccountSignalsSidebarItems(
    companyId: number,
  ): Promise<AccountSignalsSidebarItemsResponse> {
    return this.get<AccountSignalsSidebarItemsResponse>(
      `signals/configurations/getSignalConfigurationStats?companyId=${companyId}`,
    );
  }

  public getAllSavedViewsSidebarItems(): Promise<any> {
    return this.get<any[]>('/sidebar/saved-views');
  }

  public getFilteredSignals(
    url: string,
  ): Promise<SignalOccurenceLightResponse> {
    return this.get<SignalOccurenceLightResponse>(url);
  }
}

export const AllSignalsAPI = new AllSignalsAPIClient();
